import axios from 'axios';
import md5 from 'js-md5';
import useAuthorize from 'modules/useAuthorize';
import apiClientConfig from './config';

const [user] = useAuthorize();
const API = apiClientConfig[process.env.NODE_ENV || 'development'];
const PLATFORM = {
  plat: 'wp',
  plat_name: 'gjgj'
};

export type Method = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface APIConfig {
  defaultToken?: string;
}

async function apiRequest(
  method: Method,
  url: string,
  data: any,
  config: APIConfig
) {
  let requestData = data;
  let params = data;

  if (method === 'GET') {
    requestData = null;
  } else {
    params = null;
  }

  const token = config.defaultToken || user.token;

  const response = await axios(url, {
    data,
    headers: {
      token
    },
    method,
    params
  });

  return response.data;
}

function createClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return (data?: any, apiConfig: APIConfig = {}) => {
    const config = {
      ...defaultConfig,
      ...apiConfig
    };

    const requestData = {
      ...defaultData,
      ...data
    };

    return apiRequest(method, url, requestData, config);
  };
}

function createBaseClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(method, API.BASE_HOST + url, defaultData, defaultConfig);
}

function createInviteClient(
  method: Method,
  url: string,
  defaultData: any = {},
  defaultConfig: APIConfig = {}
) {
  return createClient(
    method,
    API.INVITE_HOST + url,
    defaultData,
    defaultConfig
  );
}

const apiClient = {
  base: {
    // 0053 - 增加银行
    addPay: createBaseClient('POST', '/v1/bank'),
    // 0052 - 获取支付方式
    getPayment: createBaseClient('GET', '/v1/bank'),
    // 0066 - 登录
    login: createBaseClient('POST', '/v1/member', { action: 'login' }),
    // 0011.2 - 授权登录
    oauth: ({ route = '', mp = '' } = { route: '', mp: '' }) => {
      // 记录用户进行了 oauth 操作，以便后续决定是否要接受 token
      localStorage.setItem('oauth', 'true');

      const host = route
        ? window.location.host + route
        : window.location.host + window.location.pathname;

      let plat = '';
      let platName = '';

      if (mp) {
        plat = 'wp';
        platName = mp;
      }

      const url =
        API.OAUTH_URL +
        `?token=${user.token ||
          ''}&host=${host}&plat_name=${platName}&plat=${plat}`;

      window.location.href = url;
    },

    // 0025 - 发送短信
    sendCode: async (data: any, config: APIConfig = {}) => {
      const response = await apiClient.base.serverTimestamp();

      if (response.status !== 10000) {
        return response;
      }

      const defaultToken = md5(
        response.body.time + '325e1fe67673f75185c38bddb0e92bb1'
      );

      return createBaseClient('GET', '/v1/vcode', {}, { defaultToken })(
        data,
        config
      );
    },
    // 0001 - 获取服务器时间
    serverTimestamp: createBaseClient('GET', '/v1/server'),
    // 0061 - 用户信息
    userinfo: createBaseClient('GET', '/v1/member', PLATFORM),
    // 0006 - 校验短信
    validateCode: createBaseClient('POST', '/v1/vcode'),
    // 0015 - 微信签名
    weixinSign: createBaseClient('GET', '/v1/weixin', PLATFORM),
    // 0043 - 账户提现
    withdraw: createBaseClient('POST', '/v1/invite'),

    // 上传文件
    file: createBaseClient('GET', '/v1/file')
  },
  invite: {
    award: createInviteClient('GET', '/v1/invite', { action: 'money' }),
    list: createInviteClient('GET', '/v1/invite', { action: 'list' }),
    poster: createInviteClient('GET', '/v1/invite')
  }
};

export default apiClient;
